<template>
	<div class="d-flex align-start justify-space-between">
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			:close-on-content-click="false"
			min-width="500"
			max-width="500"
			content-class="contract-annulation-info-container"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-icon
					icon
					dark
					class="ml-1 exclude-from-block"
					size="20"
					:color="color"
					v-bind="attrs"
					v-on="on">mdi-information-box-outline</v-icon>
			</template>
			<div style="color: black;">
				<div class="d-flex align-center justify-space-between">
					<p class="mb-0 font-weight-bold caption">Historial de los Subcontratos</p>
				</div>
				<v-divider class="my-2"></v-divider>
				<div v-if="loadingContracts" class="d-flex align-center justify-center" style="height: 200px;">
					<v-progress-circular
						indeterminate
						color="primary"
					></v-progress-circular>
				</div>
				<div v-else-if="contracts?.length === 0" class="d-flex flex-column align-center justify-center" style="height: 200px;">
					<v-icon
						icon
						dark
						size="30"
						class="mb-2"
						:color="color">mdi-information-off-outline</v-icon>
					<p class="mb-0 caption">No existe historial de subcontratos para este proyecto.</p>
				</div>
				<div v-else>
					<v-tabs
						v-model="contractTab"
						background-color="transparent"
						color="#FF120B"
						class="contract-tabs"
						show-arrows
					>
						<v-tab
							v-for="contract in contracts"
							:key="contract.id"
						>
							<div class="d-flex flex-column align-center">
								<div class="d-flex align-center justify-space-between mb-1" style="width: 100%;">
									<span class="text--disabled" style="font-size: 9px;">Contrato</span>
									<v-chip
										:color="getFinalStatus(contract).color"
										label
										outlined
										x-small
									>
										<b style="font-size: 8px;">{{ getFinalStatus(contract).text }}</b>
									</v-chip>
								</div>
								<span class="caption font-weight-bold">{{ getContractCode(contract) }}</span>
							</div>
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="contractTab">
						<v-tab-item
							v-for="contract in contracts"
							:key="contract.id"
						>
							<div class="pa-3" style="max-height: 300px;overflow-y: auto;">
								<div v-if="!contract.status_requests || contract.status_requests.length === 0" class="d-flex flex-column align-center justify-center py-8">
									<v-icon color="grey" size="40" class="mb-2">mdi-information-off-outline</v-icon>
									<p class="mb-0 caption text--disabled text-center">No hay historial de solicitudes de suspensión/restauración para este contrato.</p>
								</div>
								<v-list v-else dense class="py-0" style="background-color: transparent;">
									<v-list-item dense class="mb-0 px-0" v-for="(history, index) in contract.status_requests" :key="'kk' + contract.status_requests.id + '_' + index">
										<div class="d-flex flex-column flex-1 mb-2">
											<div>
												<div class="d-flex justify-space-between align-start">
													<div>
														<v-chip
															color="grey"
															label
															outlined
															x-small>
															<div class="d-flex align-center justify-center">
																<p class="mb-0 mr-1">Tipo: <b>{{history.type == 1 ? 'Suspensión':'Restauración'}}</b></p>
																<div style="height: 7px;width: 7px; border-radius: 7px;opacity: 0.7;" :style="history.type == 1 ? 'background-color: #FF1209;':'background-color: green;'"></div>
															</div>
														</v-chip>
														<div class="d-flex align-center justify-start" style="gap: 8px;">
															<v-avatar size="30">
																<img :src="history?.user?.profile?.avatar" v-if="history?.user?.profile?.avatar"/>
																<v-icon v-else small color="#524D4D">mdi-account</v-icon>
															</v-avatar>
															<div>
																<p class="mb-0 caption font-weight-bold">{{ getUserName(history) }}</p>
																<p class="mb-0 text--disabled" style="font-size: 11px;">{{ history?.user?.email }}</p>
															</div>
														</div>
													</div>
													<div>
														<p class="mb-0 text-right text--disabled" style="font-size: 10px;">Fecha y Hora</p>
														<p class="mb-0 caption font-weight-bold	text-right">{{ history.created_at | toDateTime }}</p>
														<v-chip
															:color="getHistoryStatus(history).color"
															label
															outlined
															x-small
															class="px-1 text-center d-flex justify-center"
															style="width: 100%;"
														>
															<b>{{ getHistoryStatus(history).text }}</b>
														</v-chip>
													</div>
												</div>
												<div v-if="history?.observation || history?.comment" style="background-color: #f5f5f5;border-radius: 10px;padding: 3px 10px;border: 1px solid #b6b6b6;margin-top: 5px;">
													<p class="mb-0 text--disabled" style="font-size: 10px;">Motivo / Comentario:</p>
													<p
														class="mb-0 caption"
														style="overflow-wrap: break-word; word-break: break-word; min-width: 0;"
													>{{ history.observation || history?.comment }}</p>
												</div>
											</div>
											<v-divider class="mt-2" v-if="index < (contract.status_requests.length - 1)"></v-divider>
										</div>
									</v-list-item>
								</v-list>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
import {getSubcontractProjectHistory} from '@/helpers/api/contracts'
import { getProjectCode } from '@/helpers/helpers'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'

export default {
	name: 'ProjectAnnulationInfo',
	props: {
		project: {
			type: Object,
			required: true
		},
		item_id: {
			type: Number,
			required: true
		},
		item_type: {
			type: String,
			required: true
		},
		color: {
			type: String,
			required: false,
			default: 'black'
		}
	},
	components: {
	},
	data() {
		return {
			menuOpen: false,
			contracts: null,
			loadingContracts: false,
			contractTab: 0,
			contractStatuses,
			requiredRule: [
				v => !!v || 'Campo requerido'
			]
		};
	},
	computed: {
		main_contract(){
			return this.contract?.subcontract_parent
		},
	},
	watch: {
		menuOpen: {
			handler() {
				if(this.menuOpen){
					this.getSubcontractHistory();
				}
			},
			deep: true
		}
	},
	mounted() {
	},
	methods: {
		getContractCode(contract) {
			if(!contract || !this.project) return '';
			return getProjectCode(contract, this.project)
			// if(this.main_contract){
			// 	let append = ''
			// 	if(contract.addendum_to_contract_id){
			// 		append = ` - ANX Nº ${contract.addendum_index}`
			// 	}
			// 	else if(contract.subcontract_to_contract_id){
			// 		append = ` - SUB Nº ${contract.subcontract_index}`
			// 	}
			// 	return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${this.main_contract?.info?.contract_prefix_index} ${append}`
			// }
			// return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		async getSubcontractHistory(){
			this.loadingContracts = true;
			const response = await getSubcontractProjectHistory({
				item_id: this.item_id,
				item_type: this.item_type
			})
			if(response.code == 200){
				this.contracts = response.contracts
			}
			this.loadingContracts = false;
		},
		getHistoryStatus(history){
			if(history.type == 1){
				if(history.status === 0){
					return {
						text: 'Solicitado',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Suspendido',
						color: '#FF1209'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Rechazada',
						color: 'grey'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
			else {
				if(history.status === 0){
					return {
						text: 'Solicitado',
						color: 'warning'
					}
				}
				else if(history.status === 1){
					return {
						text: 'Restaurado',
						color: 'success'
					}
				}
				else if(history.status === 2){
					return {
						text: 'Rechazada',
						color: '#FF1209'
					}
				}
				return {
					text: 'Otro',
					color: 'grey'
				}
			}
		},
		getFinalStatus(contract) {
			const history = contract.status_requests?.[0]
			if (!history) {
				if(contract.last_status?.status == contractStatuses.RECHAZADO){
					return { text: 'Rechazado', color: '#FF1209' }
				}
				return { text: 'Sin historial', color: 'grey' }
			}

			if (history.type == 1) {
				if (history.status === 0) return { text: 'Solicitud de Suspensión', color: 'warning' }
				if (history.status === 1) return { text: 'Suspendido', color: '#FF1209' }
				if (history.status === 2) return { text: 'Suspensión Rechazada', color: 'grey' }
			} else {
				if (history.status === 0) return { text: 'Solicitud de Restauración', color: 'warning' }
				if (history.status === 1) return { text: 'Restaurado', color: 'success' }
				if (history.status === 2) return { text: 'Restauración Rechazada', color: '#FF1209' }
			}

			return { text: 'Otro', color: 'grey' }
		},
		getUserName(history){
			const user = history.user
			if(user?.profile){
				return user.profile.name + ' ' + user.profile.lastname + ' ' + user.profile.second_lastname	
			}
			return '';
		},
		closeModal() {
			this.menuOpen = false;
		}
	}
};
</script>

<style scoped>
	.contract-annulation-info-container{
		background-color: white;
		max-width: 550px;
		min-width: 550px;
		width: 100%;
		padding: 10px;
		border: 1px solid grey;
		opacity: 1!important;
	}
	.contract-tabs {
		padding: 8px 4px;
	}
	.contract-tabs /deep/ .v-tabs-bar {
		background-color: transparent !important;
	}
	.contract-tabs /deep/ .v-tab {
		text-transform: none;
		font-weight: 500;
		min-height: 40px;
		padding: 6px 12px;
		margin: 0 4px;
		border-radius: 8px;
		border: 1px solid #e0e0e0;
		background-color: #f5f5f5;
		color: #666;
		transition: all 0.2s ease;
	}
	.contract-tabs /deep/ .v-tab:hover {
		background-color: #e8e8e8;
		border-color: #d0d0d0;
	}
	.contract-tabs /deep/ .v-tab--active {
		background-color: #FF120B !important;
		color: white !important;
		border-color: #FF120B !important;
		box-shadow: 0 2px 4px rgba(255, 18, 11, 0.2);
	}
	.contract-tabs /deep/ .v-tab--active .text--disabled {
		color: rgba(255, 255, 255, 0.7) !important;
	}
	.contract-tabs /deep/ .v-tab--active .caption {
		color: white !important;
	}
	.contract-tabs /deep/ .v-tab--active .v-chip {
		color: white !important;
		border-color: white !important;
	}
	.contract-tabs /deep/ .v-tab--active .v-chip b {
		color: white !important;
	}
	.contract-tabs /deep/ .v-tabs-slider-wrapper{
		display: none;
	}
</style>